module.exports = __webpack_public_path__ + "img/ys_2.5f156c39.png";